module.exports = __webpack_public_path__ + "static/img/badge-trap-scheduled-mandatory.eee746c.svg";